import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { I18nService, StorageService } from './core/services/general-utils';
import { environment } from '../environments/environment';
import { APP_VERSION_KEY, LANG_KEY, PRIMARY_COLOR } from './shared/constants/app.constants';
import { TranslateService } from '@ngx-translate/core';
import { PrimeNGConfig } from 'primeng/api';
import * as Chart from 'chart.js';

@Component({
  selector: 'body',
  template: `
    <router-outlet></router-outlet>
  `,
  providers: [I18nService]
})
export class AppComponent implements OnInit {
  
  constructor(
    private router: Router,
    private i18nService: I18nService,
    private storageService: StorageService,
    private translateService: TranslateService,
    private primengConfig: PrimeNGConfig) {
    this.controlAppVersion();
  }

  ngOnInit() {
    this.primengConfig.ripple = true;
    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      window.scrollTo(0, 0);
    });
    const currentLang: string = sessionStorage.getItem(LANG_KEY);
    const browserLang = this.translateService.getBrowserLang();
    this.i18nService.init(currentLang ? currentLang : (browserLang.indexOf('it') !== -1 ? 'it' : 'gb'), environment.supportedLanguages);
    this.translateService.use(currentLang ? currentLang : (browserLang.indexOf('it') !== -1 ? 'it' : 'gb'));
    this.translateService.get('primeng').subscribe(res => this.primengConfig.setTranslation(res));
    this.initializeChartJsDefaults();
  }

  /**
   * control version app: if changed force logout
   */
  controlAppVersion() {
    const storageVersion = this.storageService.getItem(APP_VERSION_KEY);
    console.log('Client Store App version', storageVersion, APP_VERSION_KEY, environment.appVersion);
    if (!storageVersion || storageVersion !== environment.appVersion) {
      this.storageService.clear();
      this.storageService.setItem(APP_VERSION_KEY, environment.appVersion);
      this.router.navigate(['/login']);
    }
  }

  initializeChartJsDefaults() {
    Chart.defaults.global.defaultFontColor = PRIMARY_COLOR;
    Chart.defaults.global.defaultFontSize = 14;
    Chart.defaults.global.defaultFontStyle = '600';
  }

}